"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseStatusEnum = void 0;
var ExpenseStatusEnum;
(function (ExpenseStatusEnum) {
    ExpenseStatusEnum[ExpenseStatusEnum["PURCHASE_PENDING"] = 0] = "PURCHASE_PENDING";
    ExpenseStatusEnum[ExpenseStatusEnum["DOCS_NEEDED"] = 1] = "DOCS_NEEDED";
    ExpenseStatusEnum[ExpenseStatusEnum["INVOICE_PENDING"] = 2] = "INVOICE_PENDING";
    ExpenseStatusEnum[ExpenseStatusEnum["APPROVED"] = 3] = "APPROVED";
    ExpenseStatusEnum[ExpenseStatusEnum["DECLINED"] = 4] = "DECLINED";
    ExpenseStatusEnum[ExpenseStatusEnum["REVIEWED"] = 5] = "REVIEWED";
    ExpenseStatusEnum[ExpenseStatusEnum["PAID"] = 6] = "PAID";
    ExpenseStatusEnum[ExpenseStatusEnum["DONE"] = 7] = "DONE";
})(ExpenseStatusEnum || (exports.ExpenseStatusEnum = ExpenseStatusEnum = {}));
